module.exports = __webpack_public_path__ + "img/0xd6abe115ecb75e1fa0b42f5e85934ce8c1ae2893 .26e1aae2.png";